import { CreateTicketEvaluationsDTO } from '../models/TicketEvaluations'
import { TicketRepository } from '../repositories/TicketRepository'

export function CreateTicketEvaluationCase(ticketRepository: TicketRepository) {
  return async function ({
    ticketId,
    data
  }: {
    ticketId: string
    data: CreateTicketEvaluationsDTO
  }) {
    return await ticketRepository.createTicketEvaluation({
      ticketId,
      data
    })
  }
}
